import * as React from 'react';
import { cn } from '../../utils';

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: React.ReactNode;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, id, ...props }, ref) => {
    const checkboxId = id || React.useId();

    return (
      <label
        htmlFor={checkboxId}
        className="flex items-start gap-3 cursor-pointer select-none"
      >
        <input
          type="checkbox"
          id={checkboxId}
          ref={ref}
          className={cn(
            'mt-0.5 w-4 h-4 rounded border-gray-300 dark:border-neutral-700 bg-white dark:bg-neutral-900 text-primary',
            'focus:ring-2 focus:ring-primary/30 focus:ring-offset-0',
            'cursor-pointer',
            'disabled:cursor-not-allowed disabled:opacity-50',
            className
          )}
          {...props}
        />
        {label && (
          <span className="text-sm text-gray-600 dark:text-neutral-300">{label}</span>
        )}
      </label>
    );
  }
);
Checkbox.displayName = 'Checkbox';

export { Checkbox };